import React from 'react';
import { Box, Typography } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import WidgetCard from './WidgetCard';
import { formatServerDate, useWidgetData } from './useWidgetData';

interface StatusItem {
  documentId: number;
  statusName: string;
  description: string;
  user: string;
  sender: string;
  recipient: string;
  viaWarehouse: string | null;
  recordedAt: string;
}

interface StatusesResponse {
  items: StatusItem[];
  limit: number;
}

const ACCENT = '#0d9488';

/** Виджет «Последние статусы документов» - компактный список для узкой колонки. Право: home.documents.statuses.view (+ .limit) */
const DocumentStatusesWidget: React.FC = () => {
  const { data, loading, error, reload } = useWidgetData<StatusesResponse>('/api/v2/home/documents/statuses');
  const items = data?.items || [];

  return (
    <WidgetCard
      title="Статусы документов"
      icon={<HistoryIcon />}
      accent={ACCENT}
      loading={loading}
      error={error}
      onRefresh={reload}
    >
      {!loading && items.length === 0 ? (
        <Typography sx={{ p: 2, fontSize: 13, color: '#94a3b8' }}>Записей нет</Typography>
      ) : (
        items.map((r, i) => (
          <Box
            key={`${r.documentId}-${r.recordedAt}-${i}`}
            sx={{ px: 2, py: 1.1, borderTop: i ? '1px solid #f1f5f9' : 'none', '&:hover': { bgcolor: '#f8fafc' } }}
          >
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#0f172a', whiteSpace: 'nowrap' }}>№ {r.documentId}</Typography>
              <Typography
                sx={{
                  fontSize: 12.5, fontWeight: 500, color: ACCENT, minWidth: 0,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                }}
              >
                {r.statusName}
              </Typography>
              <Box sx={{ flex: 1 }} />
              <Typography sx={{ fontSize: 11.5, color: '#94a3b8', whiteSpace: 'nowrap' }}>{formatServerDate(r.recordedAt)}</Typography>
            </Box>
            <Typography sx={{ fontSize: 12.5, color: '#334155', mt: 0.25, lineHeight: 1.4 }}>
              {r.sender || '-'} → {r.recipient || '-'}
              {r.viaWarehouse && <Typography component="span" sx={{ fontSize: 12, color: '#94a3b8' }}> (через {r.viaWarehouse})</Typography>}
            </Typography>
            {r.user && <Typography sx={{ fontSize: 11.5, color: '#94a3b8' }}>{r.user}</Typography>}
          </Box>
        ))
      )}
    </WidgetCard>
  );
};

export default DocumentStatusesWidget;
